import { render, staticRenderFns } from "./InputOutputContainerLoader.vue?vue&type=template&id=b8ba9b06"
import script from "./InputOutputContainerLoader.vue?vue&type=script&lang=js"
export * from "./InputOutputContainerLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports